export default __webpack_public_path__ + "static/media/Pfont-Bold.ab2bf8ed.ttf";